export default "__VITE_ASSET__d66047c0__"